module.exports = __webpack_public_path__ + "assets/img/bg.e5a0ad14.png";